import * as React from 'react';
import { CodeSplit, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

export class DeeplinkBuilderController implements Controller {
  public pageId = 'DeeplinkBuilder';
  public path = '/:localeName/deeplink-builder';
  public routeName = 'deeplinkBuilder';
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/deeplink-builder-page'),
  );
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Deeplink Builder' }) as Promise<PageData>;
  }
}
